import $ from "jquery";
import StateManager from "../scuba/StateManager";


class LoginForm {
  constructor($el) {
    var self = this;
    self.$el = $el;
    $el.on("submit", $.proxy(self.submitForm, self))
  }
  submitForm(e){
    var self = this;
    self.$el.find(".js-login-form__alert").remove();
    $.post(window.wp.ajax, `${self.$el.serialize()}&action=login`, data => {
      $(`<div class="c-alert js-login-form__alert">${data.message}</div>`).prependTo(self.$el);
      if (data.loggedin == true){
        document.location.reload();
      }
    });
    e.preventDefault();
  }
}

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    $(node).find(".js-login-form").each(function(i, el) {
        var loginForm = new LoginForm($(el));
        $(el).data("loginform", loginForm);
    });
});


// WEBPACK FOOTER //
// ./scripts/components/LoginForm.js